<template>
    <div class="bubble-container">
        <div class="rounded-box has-background-primary has-text-white">
            <p class="title is-3">{{ number }}</p>
        </div>
        <p class="is-size-6 has-text-weight-bold pt-2">{{ title }}</p>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: undefined,
        },
        number: {
            type: Number,
            default: undefined,
        },
    },
};
</script>

<style scoped>
.rounded-box {
    height: 90px;
    width: 90px;
    display: flex !important;
    justify-content: center;
    align-items: center;
    margin: auto;
}
.bubble-container {
    justify-content: center;
    align-items: center;
}
</style>
